module.exports = __webpack_public_path__ + "img/mission-planet-hero.jpg?111c46e72d056eec1c863fb556b1f0ee";